module.exports = __webpack_public_path__ + "img/soundcheck1920.f1697bd8.png";